export function handleRarityLabel(value) {
  value = value.toLowerCase();

  const options = {
    common: "Comum",
    uncommon: "Incomum",
    rare: "Raro",
    epic: "Épico",
    legendary: "Lendário",
    mythic: "Mítico",
  };

  return options[value];
}
